__webpack_require__.p = "/picto-selector/";